import React from 'react';

import { PersonOrgType } from '@ndvr/customer-api';

import { useRequiredParams } from 'utils';
import { VerticalLayout } from 'widgets';

import { useCommandCenterHouseholdProfile } from '../household-queries';
import { JointMembersList } from './JointMembersList';
import { OrgList } from './OrgList';
import { PersonsList } from './PersonsList';

export const HouseholdMembersTab = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);

    const { data: accountProfile } = useCommandCenterHouseholdProfile(globalAccountGUID);
    const profiles = accountProfile?.personOrgFinancialProfiles || [];

    return (
        <VerticalLayout $gap={48}>
            <PersonsList profiles={profiles} />
            <JointMembersList profiles={profiles} />
            <OrgList profiles={profiles} orgType={PersonOrgType.TRUST} />
            <OrgList profiles={profiles} orgType={PersonOrgType.ORGANIZATION} />
        </VerticalLayout>
    );
};
